import { Component, inject, OnInit } from "@angular/core";
import { StorageService } from "src/app/shared/services/storage.service";
import AppConstants from "src/app/shared/constants/app.constants";
import { Router, RouterLink } from "@angular/router";
import { LoaderService } from "src/app/shared/services/loader.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ProfileService } from "src/app/shared/services/profile.service";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { MenuController, NavController, Platform } from "@ionic/angular";
import { AlarmDataService } from "src/app/shared/services/alarm-data.service";
import { HttpService } from "src/app/shared/services/http.service";
import { ToasterService } from "src/app/shared/services/toaster.service";
import { IonHeader, IonMenu, IonToolbar, IonContent, IonMenuToggle, IonFooter, IonIcon, IonButton } from "@ionic/angular/standalone";
import { PluginListenerHandle } from "@capacitor/core";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { SafariViewController } from "@awesome-cordova-plugins/safari-view-controller/ngx";
import { environment } from "src/environments/environment";
import { addIcons } from "ionicons";
import { settingsOutline } from "ionicons/icons";
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.page.html",
  styleUrls: ["./sidemenu.page.scss"],
  standalone: true,
  providers: [InAppBrowser, SafariViewController],
  imports: [IonButton, IonIcon, IonFooter, IonContent, IonToolbar, IonHeader, TranslateModule, IonMenu, IonMenuToggle, RouterLink],
})
export class SidemenuPage implements OnInit {
  userData: any;
  activeAlarmCount: any;
  appVersion: any;
  deviceInfo: any;
  private appUrlListener: PluginListenerHandle | null = null;
  private safariViewController = inject(SafariViewController);
  private menuCtrl = inject(MenuController);
  constructor(
    private router: Router,
    private iab: InAppBrowser,
    private platform: Platform,
    private navCtrl: NavController,
    private httpService: HttpService,
    private translate: TranslateService,
    private loaderService: LoaderService,
    private profileService: ProfileService,
    private storageService: StorageService,
    private toasterService: ToasterService,
    private alarmDataService: AlarmDataService,
    private authService: AuthService
  ) {
    this.init();
    addIcons({
      settingsOutline,
    });
  }

  async init() {
    this.profileService.userData$.subscribe((data) => {

      if (data) this.userData = data;
    });
    this.deviceInfo = await this.storageService.getItemIonic(
      AppConstants.DEVICE_INFO
    );
    const deviceVersion = await this.storageService.getItemIonic(
      AppConstants.APP_VERSION
    );
    this.appVersion = deviceVersion;
  }

  async ngOnInit() {
    this.alarmDataService.activeCount$.subscribe((count) => {
      this.activeAlarmCount = count;
    });
  }

  removeSaveAlarm(){
   
  }

  async navigateToAlarmMap() {
     this.alarmDataService.clearAlarm();
    this.navCtrl.navigateRoot("/pages/map_menu");
  }


  goToTerms() {
    this.router.navigate(["/pages/terms"]);
  }

  goToPrivacy() {
    this.router.navigate(["/pages/privacy"]);
  }

  async logout() {
    const shouldLogout = await this.loaderService.showConfirmPopup(
      this.translate.instant("header_msg"),
      this.translate.instant("Exit_msg"),
      this.translate.instant("Logout"),
      this.translate.instant("No")
    );
    const payload = {
      playerId: this.deviceInfo.uuid,
      deviceType: 2,
    };
    if (this.deviceInfo.operatingSystem === "android") {
      payload.deviceType = 1;
    } else if (this.deviceInfo.operatingSystem === "ios") {
      payload.deviceType = 0;
    } else {
      payload.deviceType = 2;
    }
    if (shouldLogout) {
      this.httpService.patch("auth/user/logout", payload)
        .then((res) => {
          this.profileService.logOut();
          this.toasterService.toastMsg(this.translate.instant(res.message));
          setTimeout(() => {
            this.authService.authToken.next("");
          }, 1000);
        })
        .catch((err) => {
          console.error("Upload failed", err);

        })
    }
  }

  async navigateToChangeLog() {
    if (this.platform.is("capacitor") && (this.platform.is("ios") || this.platform.is("ipad"))) {
      this.loaderService.showLoader(this.translate.instant("toast_please_wait"));
      let deepLinkPath = btoa('myapp://login/token');
      await this.removeDeepLinkListener();

      this.appUrlListener = await App.addListener('appUrlOpen', async (event: URLOpenListenerEvent) => {
        const url = event.url;
        if (url.includes('myapp://login/token')) {
          this.safariViewController.hide();
        }
      });
      const convert_url =
        `https://www.rescue-digital.de/blog/retteralarm-4?redirect_url=` +
        deepLinkPath;
      this.safariViewController.isAvailable().then((available: boolean) => {
        if (available) {
          this.safariViewController.show({
            url: convert_url,
            hidden: false,
            animated: true,
            transition: 'curl',
            enterReaderModeIfAvailable: true,
            tintColor: '#ff0000'
          }).subscribe((result: any) => {
            if (result.event === 'opened') {
            } else if (result.event === 'loaded') {

            } else if (result.event === 'closed') {
              this.loaderService.hideLoader();
            }
          });
        }
      }).catch((error: any) => {
        console.error('Error opening SafariViewController:', error);
        this.loaderService.hideLoader();
      });
    } else if (this.platform.is("capacitor") && this.platform.is("android")) {
      let deepLinkPath = btoa("https://myapp/auth/login/token");
      const convertUrl =
        `https://www.rescue-digital.de/blog/retteralarm-4?redirect_url=` +
        deepLinkPath;
      const browser = this.iab.create(convertUrl, "_blank", {
        toolbar: "yes",
        closebuttoncaption: this.translate.instant("back"),
        closebuttoncolor: "#ffffffff",
        toolbarposition: "top",
        hidenavigationbuttons: "yes",
        hideurlbar: "yes",
        location: "no",
        clearcache: "no",
        cleardata: "no",
        clearsessioncache: "no",
        hardwareback: "no",
        zoom: "no",
      });
      browser.on("loadstart").subscribe((event: any) => {
        const currentUrl = event.url;
        if (currentUrl.startsWith("https://myapp/auth/login/token")) {
          const token = new URL(currentUrl).searchParams.get("accessToken");
          browser.close();
        }
      });
    } else {
      // let deepLinkPath = btoa("http://localhost:8100/auth/login");
       let deepLinkPath = btoa("https://zeus.development.retteralarm.de/pages/my-alarm");
      let convert_url =
        `https://www.rescue-digital.de/blog/retteralarm-4?redirect_url=` +
        deepLinkPath; 

      window.location.href = convert_url;
    }
  }

  async removeDeepLinkListener() {
    if (this.appUrlListener) {
      await this.appUrlListener.remove();
      this.appUrlListener = null;
    }
  }
}
